import { useSelector } from 'react-redux';

import { RootState } from 'store';

const useUserAccount = () => useSelector((state: RootState) => state.user.accountResult);

export default useUserAccount;
